import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllCategories } from 'Api/masters/category';

export const fetchCategoryAction = createAsyncThunk(
	'category',
	async (params: any, { rejectWithValue }) => {
		try {
			const response = await getAllCategories(params);
			return response.data;
		} catch (error: any) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);
